"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../NotifyCumulus/styles");
const Inner = exports.Inner = (0, _mui.styled)(_mui.Box)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: 'inherit',
  justifyContent: 'center',
  textAlign: 'center'
});
const Root = exports.Root = (0, _mui.styled)(_styles.Root)(({
  theme
}) => ({
  height: _styles.MOBILE_HEIGHT,
  [theme.breakpoints.up('sm')]: {
    height: _styles.DESKTOP_HEIGHT
  }
}));